import React, {useState, useEffect} from 'react'
import {CheckIcon, CommentIcon} from './'
import { urlFor } from '../lib/client'
import { useActionState } from 'react'
import { AiFillExclamationCircle } from 'react-icons/ai';
import {VisDiv} from './';
import nonConformity from '../sanity_ecommerce/schemas/nonConformity';


const NonConformityPin = ({label, item, array, setArray, itemOnSave=()=>{}, iconSize="40px", initialValue=false, pinDisabled=false}) => {
    
    
    const [value, setValue] = useState(initialValue)
    useEffect(()=>{setValue(initialValue)},[initialValue])
    //useEffect(()=>{setValue(initialValue)},[initialValue, item, array])
/*     useEffect(()=>{
        if(array?.length>0){
            setValue
        }
    },[]) */


  const onClickPin = () => {
    if(pinDisabled) return
    if(!value) {
        itemOnSave({item, action: "added"})
        setValue(true)
        setArray ([...!Array.isArray(array) ? [] : array, item])
        //console.log("falsetotrue", [...array, item] )
    }
    if(value) {
        setValue(false)
        itemOnSave({item, action: "removed"})
        const newArray = !Array.isArray(array) ? [] : array.filter?.((x)=>x?._id !== item?._id)
        setArray(newArray)
        //console.log("truetofalse", array.filter?.((x)=>x._id !== item._id) )
    }
   
  }
  const disabledStyle = pinDisabled ? {backgroundColor:"grey"}:{}
  
  return (
    <div 
    className='nonConformity-pin-container'
    onClick={onClickPin}
    style={{...disabledStyle}}
    >
        <div className='nonConformity-left-container'>
            <CheckIcon
            status={value}
            />
        </div>
        { item?.icon && (<div style={{display:"flex", margin:"5px"}}><img src={urlFor(item?.icon)} alt="register-icon" className="register-logo" style={{width: iconSize, height: iconSize }} /></div>)}

    
        <div className='nonConformity-title-container '>
            <div className='nonConformity-info-text'>
                {label}
            </div>
        </div>
        {/*<div className='icons-container'>
            icons()                     
        </div>*/} 
             <VisDiv rules={[item?.notification]}>
                <AiFillExclamationCircle fontSize={27} color={"red"} />
            </VisDiv>
    </div>
  )
}

export default NonConformityPin
